import { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import PageOne from "./components/PageOne";
import PageTwo from "./components/PageTwo";
import PageThree from "./components/PageThree"
import PageFour from "./components/PageFour"
import PageFive from "./components/PageFive"
import PageSix from "./components/PageSix"
import PageSeven from "./components/PageSeven"
import { FormattedMessage } from "react-intl";
import PageEight from "./components/PageEight";


const pages = [PageOne, PageThree, PageTwo, PageFour, PageFive, PageSix, PageSeven, PageEight];
const pageNames = ["p1", "p3", "p2", "p4", "p5", "p6", "p7", "p8"];

export default function MainPage({initial = 0}) {
    const [currentPage, setCurrentPage] = useState(initial);
    const [isScrolling, setIsScrolling] = useState(false);

    const handleScroll = (e) => {
        if (isScrolling) return;

        setIsScrolling(true);

        if (e.deltaY > 0 && currentPage < pages.length - 1) {
            setCurrentPage((prev) => prev + 1);
        } else if (e.deltaY < 0 && currentPage > 0) {
            setCurrentPage((prev) => prev - 1);
        } else if (e.deltaY < 0 && currentPage === 0) {
            setCurrentPage(pages.length - 1);
        } else if (e.deltaY > 0 && currentPage === pages.length - 1) {
            setCurrentPage(0);
        }

        setTimeout(() => setIsScrolling(false), 800); // debounce scroll
    };

    useEffect(() => {
        window.addEventListener("wheel", handleScroll, { passive: true });
        return () => window.removeEventListener("wheel", handleScroll);
    }, [currentPage, isScrolling, handleScroll]);

    const CurrentPage = pages[currentPage];

    return (
        <div className="mainContainer">
            <div className="navbar">
                <a href="/">
                    <img src="assets/pb_icon.png" alt=""/>
                </a>
                {pages.map((_, i) => (
                <button
                    key={i}
                    onClick={() => setCurrentPage(i)}
                    className={`${
                    i === currentPage && "active"
                    }`}
                >
                    <FormattedMessage id={"main.title."+pageNames[i]}/>
                </button>
                ))}
            </div>
            <div className="pBBackground">
                <AnimatePresence mode="wait">
                    <CurrentPage key={currentPage} jump={setCurrentPage} forward={false}/>
                </AnimatePresence>
            </div>
        </div>
    );
}